import {
	Box,
	Table,
	Tbody,
	Td,
	Tr,
	Text,
	useColorModeValue,
} from '@chakra-ui/react';
import {
	DETAIL_LABEL,
	DetailKind,
	ProductMasterRow,
} from './types';

function cell(value: string | undefined | null): string {
	const trimmed = (value ?? '').trim();
	return trimmed || '—';
}

type Props = {
	kind: DetailKind;
	product: ProductMasterRow;
};

export default function ProductDetailBlock({ kind, product }: Props) {
	const headerBg = useColorModeValue('secondaryGray.200', 'whiteAlpha.100');

	if (kind === 'proveedor') {
		const p = product.proveedor;
		return (
			<Box borderWidth="1px" borderRadius="md" p={3} bg={headerBg}>
				<Text fontSize="sm" fontWeight="700" mb={2}>
					{DETAIL_LABEL[kind]}
				</Text>
				<Table size="sm" variant="unstyled">
					<Tbody>
						<Tr>
							<Td fontWeight="600" w="200px">
								Código
							</Td>
							<Td>{cell(p.codigo)}</Td>
						</Tr>
						<Tr>
							<Td fontWeight="600">Descripción</Td>
							<Td>{cell(p.descripcion)}</Td>
						</Tr>
						<Tr>
							<Td fontWeight="600">Descripción del producto del proveedor</Td>
							<Td>{cell(p.descripcionProductoProveedor)}</Td>
						</Tr>
						<Tr>
							<Td fontWeight="600">Nombre contacto email</Td>
							<Td>{cell(p.nombreContacto)}</Td>
						</Tr>
						<Tr>
							<Td fontWeight="600">Email contacto proveedor</Td>
							<Td>{cell(p.email)}</Td>
						</Tr>
						<Tr>
							<Td fontWeight="600">País</Td>
							<Td>{cell(p.pais)}</Td>
						</Tr>
					</Tbody>
				</Table>
			</Box>
		);
	}

	if (kind === 'distribucion') {
		const d = product.distribucion;
		return (
			<Box borderWidth="1px" borderRadius="md" p={3} bg={headerBg}>
				<Text fontSize="sm" fontWeight="700" mb={2}>
					{DETAIL_LABEL[kind]}
				</Text>
				<Table size="sm" variant="unstyled">
					<Tbody>
						<Tr>
							<Td fontWeight="600" w="220px">
								Costo FOB x unidad
							</Td>
							<Td>{cell(d.costoFobUnidad)}</Td>
						</Tr>
						<Tr>
							<Td fontWeight="600">Costo FOB x bulto</Td>
							<Td>{cell(d.costoFobBulto)}</Td>
						</Tr>
						<Tr>
							<Td fontWeight="600">Unidad de despacho</Td>
							<Td>{cell(d.unidadDespacho)}</Td>
						</Tr>
						<Tr>
							<Td fontWeight="600">Conteo despacho</Td>
							<Td>{cell(d.conteoDespacho)}</Td>
						</Tr>
					</Tbody>
				</Table>
			</Box>
		);
	}

	if (kind === 'transporte') {
		const t = product.transporte;
		return (
			<Box borderWidth="1px" borderRadius="md" p={3} bg={headerBg}>
				<Text fontSize="sm" fontWeight="700" mb={2}>
					{DETAIL_LABEL[kind]}
				</Text>
				<Table size="sm" variant="unstyled">
					<Tbody>
						<Tr>
							<Td fontWeight="600" w="220px">
								CPE
							</Td>
							<Td>{cell(t.cpe)}</Td>
						</Tr>
						<Tr>
							<Td fontWeight="600">Código arancelario</Td>
							<Td>{cell(t.codigoArancelario)}</Td>
						</Tr>
						<Tr>
							<Td fontWeight="600">MOQ</Td>
							<Td>{cell(t.moq)}</Td>
						</Tr>
						<Tr>
							<Td fontWeight="600">Tiempo promedio de producción</Td>
							<Td>{cell(t.tiempoPromedioProduccion)}</Td>
						</Tr>
						<Tr>
							<Td fontWeight="600">Puerto 1</Td>
							<Td>{cell(t.puerto1)}</Td>
						</Tr>
						<Tr>
							<Td fontWeight="600">Puerto 2</Td>
							<Td>{cell(t.puerto2)}</Td>
						</Tr>
						<Tr>
							<Td fontWeight="600">Puerto 3</Td>
							<Td>{cell(t.puerto3)}</Td>
						</Tr>
					</Tbody>
				</Table>
			</Box>
		);
	}

	const m = product.metodoPago;
	return (
		<Box borderWidth="1px" borderRadius="md" p={3} bg={headerBg}>
			<Text fontSize="sm" fontWeight="700" mb={2}>
				{DETAIL_LABEL[kind]}
			</Text>
			<Table size="sm" variant="unstyled">
				<Tbody>
					<Tr>
						<Td fontWeight="600" w="200px">
							Advance
						</Td>
						<Td>{cell(m.advance)}</Td>
					</Tr>
					<Tr>
						<Td fontWeight="600">Balance</Td>
						<Td>{cell(m.balance)}</Td>
					</Tr>
				</Tbody>
			</Table>
		</Box>
	);
}
